import { BiPencil, BiTrashAlt } from "react-icons/bi";
import { Button } from "../../../components/ui/button";
import { PaddedIcon } from "../../../components/ui/button/Icon";
import Workspace from "../../../components/workspace";
import { useFeatureFlag } from "../../../state/featureFlagContext";

const Role = ({ role, formModal, setSelectedRole }) => {
   const { displayRoleDeleteButton } = useFeatureFlag();

   return (
      <Workspace.ItemWrapper
         onClick={() => {
            setSelectedRole(role);
            formModal.onOpen();
         }}>
         <div className="flex items-center px-4 py-5 gap-x-4 md:gap-x-6">
            <input type="checkbox" onClick={(e) => e.stopPropagation()} />
            <div className="grid gap-x-3 grid-cols-12 w-full items-center">
               <p className="col-span-6 font-bold overflow-hidden overflow-ellipsis" title="Role name">{`${role.name}`}</p>

               <p className="col-span-4 text-sm">{role.description}</p>
               <Workspace.ItemActionsWrapper>
                  <PaddedIcon variant="primary" aria-label={`Edit ${role.name}`}>
                     <BiPencil className="text-lg" />
                  </PaddedIcon>
                  {displayRoleDeleteButton ? (
                     <Button
                        variant="danger"
                        title="Delete role"
                        aria-label="Delete role"
                        onClick={(e) => {
                           e.stopPropagation();
                        }}>
                        <BiTrashAlt />
                     </Button>
                  ) : null}
               </Workspace.ItemActionsWrapper>
            </div>
         </div>
      </Workspace.ItemWrapper>
   );
};

export default Role;
